import { Alert, Fieldset, Stack } from '@chakra-ui/react'
import type { FC } from 'react'

import ContextEmptyState from '@app/pages/maps/components/contextEmptyState'
import ContextSectionContent from '@app/pages/maps/components/contextSectionContent'
import FilesSection from '@app/pages/maps/components/filesSection'
import withSuspenseWrapper from '@app/shared/withSuspenseWrapper'
import type { DomainBusinessContext } from '@app/types'
interface Props {
  businessContext?: DomainBusinessContext
  loading?: boolean
}

const ContextSection: FC<Props> = ({ businessContext = null, loading = false }) => (
  <Stack gap={2}>
    <Alert.Root status="info" variant="surface">
      <Alert.Indicator />
      <Alert.Title>The context and files you provide will inform our AI assistants.</Alert.Title>
    </Alert.Root>
    <Fieldset.Root bg="bg" borderWidth={1} borderStyle="solid" borderColor="border.default" borderRadius="xs" p={3}>
      <Fieldset.Content>
        <ContextEmptyState businessContext={businessContext} />
        <ContextSectionContent businessContext={businessContext} loading={loading} />
        <FilesSection businessContext={businessContext} loading={loading} />
      </Fieldset.Content>
    </Fieldset.Root>
  </Stack>
)

export default withSuspenseWrapper(ContextSection)
